import {
  getPlatePricesWeightList,
  getBrazedPricesWeightList,
  getPlatePricesWeightExportList,
  getBrazedPricesWeightExportList,
  postUpdateAddAllExport_Plate,
  postUpdateAddAllExport_Brazed,
  getPressuresGuidByGeomGuid,
  getFramesPricesWeightList,
  getFramesPricesWeightExportList,
  postUpdateAddAllExport_Frame,
  getGasketsPricesWeightList,
  getGasketsPricesWeightExportList,
  postUpdateAddAllExport_Gasket,
  getExportModelPlates,
  getExportModelBrazed,
  getExportModelFrames,
  getExportModelGaskets
} from "./services";

export async function getPlatePricesWeightListAction({ commit }) {
  try {
    return (await getPlatePricesWeightList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getBrazedPricesWeightListAction({ commit }) {
  try {
    return (await getBrazedPricesWeightList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getPlatePricesWeightExportListAction({ commit }) {
  try {
    return (await getPlatePricesWeightExportList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getBrazedPricesWeightExportListAction({ commit }) {
  try {
    return (await getBrazedPricesWeightExportList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function postUpdateAddAllExport_PlateAction({ commit }, payload) {
  try {
    return (await postUpdateAddAllExport_Plate(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function postUpdateAddAllExport_BrazedAction({ commit }, payload) {
  try {
    return (await postUpdateAddAllExport_Brazed(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getPressuresGuidByGeomGuidAction({ commit }, payload) {
  try {
    return (await getPressuresGuidByGeomGuid(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getFramesPricesWeightListAction({ commit }) {
  try {
    return (await getFramesPricesWeightList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getFramesPricesWeightExportListAction({ commit }) {
  try {
    return (await getFramesPricesWeightExportList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function postUpdateAddAllExport_FrameAction({ commit }, payload) {
  try {
    return (await postUpdateAddAllExport_Frame(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getGasketsPricesWeightListAction({ commit }) {
  try {
    return (await getGasketsPricesWeightList()).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getExportModelBrazedAction({ commit }) {
  try {
    return (await getExportModelBrazed()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getGasketsPricesWeightExportListAction({ commit }) {
  try {
    return (await getGasketsPricesWeightExportList()).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getExportModelFrameAction({ commit }) {
  try {
    return (await getExportModelFrames()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function postUpdateAddAllExport_GasketAction({ commit }, payload) {
  try {
    return (await postUpdateAddAllExport_Gasket(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getExportModelGasketAction({ commit }) {
  try {
    return (await getExportModelGaskets()).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getExportModelPlatesAction({ commit }) {
  try {
    return (await getExportModelPlates()).data;
  } catch (e) {
    console.log(e);
  }
}
